// extracted by mini-css-extract-plugin
export default {"main":"SavedSearches_main__4QdNx","list":"SavedSearches_list__ODBPF","loadingState":"SavedSearches_loadingState__4Dln0"};